module.exports = __webpack_public_path__ + "img/specchio-magico.e1c70064.jpg";